import { render, staticRenderFns } from "./FixedGuanggao.vue?vue&type=template&id=597764b6&scoped=true&"
import script from "./FixedGuanggao.vue?vue&type=script&lang=js&"
export * from "./FixedGuanggao.vue?vue&type=script&lang=js&"
import style0 from "./FixedGuanggao.vue?vue&type=style&index=0&id=597764b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597764b6",
  null
  
)

export default component.exports